module.exports = __webpack_public_path__ + "icon-camera-c32b0d18be6be7e83d3e.svg";